/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from './useFormUtils'
import Switch from 'react-switch'

const ReviewOneFollowUp = ({ item }) => {
  const [packaging, setPackaging] = useState({
    ReviewOneFollowUp: item?.ReviewOneFollowUp,
    ReviewOneFollowUpReason: item?.ReviewOneFollowUpReason,
  })
  const methods = useFormContext()
  const { onChangeReviewer, setSwitchReviewer, asterisk } = useFormUtils()

  return (
    <Row>
      <Col xs={3}>
        <FormGroup>
          <p>
            <strong>Additional Info Needed</strong>
          </p>
          <Controller
            as={Switch}
            name="ReviewOneFollowUp"
            id="ReviewOneFollowUp"
            defaultValue={packaging.ReviewOneFollowUp}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              setPackaging({
                ...packaging,
                ReviewOneFollowUp: checked,
              })
              return checked
            }}
            control={methods.control}
            checked={packaging.ReviewOneFollowUp}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="ReviewOneFollowUp"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={12}>
        {(item?.ReviewOneFollowUp || packaging?.ReviewOneFollowUpReason) && (
          <FormGroup>
            <p>
              <strong>Enter Additional Information Needed {asterisk}</strong>
            </p>
            <Controller
              as={<Input type="textarea" />}
              name="ReviewOneFollowUpReason"
              defaultValue={packaging.ReviewOneFollowUpReason || ''}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 250,
                  message:
                    '⚠ Additional Information Needed exceeds 250 characters.',
                },
                required: {
                  value: true,
                  message: '⚠ Enter additional information needed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                setPackaging({
                  ...packaging,
                  ReviewOneFollowUpReason: event.target.value,
                })
                return event
              }}
              disabled={!item.ReviewOneFollowUp}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="ReviewOneFollowUpReason"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
      </Col>
    </Row>
  )
}

export default ReviewOneFollowUp
